// extracted by mini-css-extract-plugin
export default {"container":"FormSuRecords_container__Us9up","formSuRecordsContainer":"FormSuRecords_formSuRecordsContainer__R9C47","header":"FormSuRecords_header__kBdgq"};